var map = {
	"./a3.png": "TKM8",
	"./a3en.png": "SELh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "l2po";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/androidMessageSet ^\.\/a3.*\.png$
// module id = l2po
// module chunks = 0